import { Component } from '@angular/core';

// TODO: when implementing functionality of search bar, make sure the following are changed:
// - wrapper div title indicating "Not implemented yet".
// - input disabled attribute
// - input cursor not-allowed
@Component({
  selector: 'recent-chat-search',
  template: `<div class="wrapper" title="Not implemented yet">
    <input class="search" type="text" placeholder="Search AI chats" disabled />
  </div>`,
  styles: `
    div.wrapper {
      padding-bottom: 8px;
      flex-shrink: 0;
    }

    input.search {
      width: 100%;
      box-sizing: border-box;
      padding: 8px 12px;
      border-radius: 8px;
      border: 1px solid var(--border);
      background: white;
      color: var(--text);
      font-size: 14px;
      outline: none;
      transition: border-color 0.15s;

      cursor: not-allowed;

      &::placeholder {
        color: var(--muted);
      }

      &:focus {
        border-color: var(--adb-blue);
      }
    }
  `,
})
export class RecentChatSearch {}
